import { render, staticRenderFns } from "./RtsStagingMark.vue?vue&type=template&id=813b8a90&scoped=true&"
import script from "./RtsStagingMark.vue?vue&type=script&lang=ts&"
export * from "./RtsStagingMark.vue?vue&type=script&lang=ts&"
import style0 from "./RtsStagingMark.vue?vue&type=style&index=0&id=813b8a90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813b8a90",
  null
  
)

export default component.exports